import React from 'react';

// Color scheme choice for the stand-alone Mental Performance app.
const MPColorsModal = ({ isOpen, onClose, schemes, active, onChoose, accent }) => {
  if (!isOpen) return null;
  const ink = '#1A1D2E';
  const mark = accent || '#0EA5E9';
  return (
    <div role="dialog" aria-modal="true" aria-labelledby="mp-colors-title" onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(10,15,30,0.62)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: '16px' }}>
      <div onClick={(e) => e.stopPropagation()}
        style={{ background: '#ffffff', color: ink, borderRadius: '16px', width: '100%', maxWidth: '460px', maxHeight: '86vh', overflowY: 'auto', padding: '24px', boxShadow: '0 12px 40px rgba(0,0,0,0.35)' }}>
        <h2 id="mp-colors-title" style={{ margin: 0, fontSize: '21px', fontWeight: 700 }}>Choose your colors</h2>
        <p style={{ margin: '6px 0 18px', fontSize: '15px', lineHeight: 1.45, color: '#4a5568' }}>
          Pick the look you like best. You can change it any time.
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {schemes.map((s) => {
            const on = s.id === active;
            return (
              <button key={s.id} type="button" aria-pressed={on} onClick={() => onChoose(s.id)}
                style={{ display: 'flex', alignItems: 'center', gap: '14px', width: '100%', textAlign: 'left', cursor: 'pointer', minHeight: '64px', padding: '10px 14px', borderRadius: '12px', border: '2px solid ' + (on ? mark : '#e2e8f0'), background: on ? '#f1f5f9' : '#ffffff', color: ink, fontFamily: 'inherit' }}>
                <span aria-hidden="true" style={{ flexShrink: 0, width: '52px', height: '40px', borderRadius: '10px', background: s.pageBgGradient, boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.15)', position: 'relative' }}>
                  <span style={{ position: 'absolute', right: '6px', bottom: '6px', width: '18px', height: '12px', borderRadius: '4px', background: s.cardBg, boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.25)' }} />
                </span>
                <span style={{ flex: 1 }}>
                  <span style={{ display: 'block', fontSize: '17px', fontWeight: 700 }}>{on ? '\u2713 ' : ''}{s.label}</span>
                  <span style={{ display: 'block', fontSize: '15px', color: '#4a5568', marginTop: '2px' }}>{s.note}</span>
                </span>
              </button>
            );
          })}
        </div>
        <button type="button" onClick={onClose}
          style={{ width: '100%', minHeight: '48px', marginTop: '18px', borderRadius: '12px', border: 'none', background: ink, color: '#ffffff', fontSize: '16px', fontWeight: 700, cursor: 'pointer' }}>
          Done
        </button>
      </div>
    </div>
  );
};

export default MPColorsModal;
